import { IconBan } from "@tabler/icons-react";
import { Alert, Stack, Text } from "@/components/ui";
import { formatFecha } from "@/shared/format/fecha";

/**
 * Alert rojo · solicitud dada de baja por Mesa de Control (acción terminal).
 * Muestra al solicitante QUIÉN la dio de baja y los motivos (decisión 38).
 */
export function DadaDeBajaAlert({
  motivos,
  dadaDeBajaPorNombre,
  dadaDeBajaAt,
}: {
  motivos: string[];
  dadaDeBajaPorNombre?: string | null;
  dadaDeBajaAt?: string | null;
}) {
  if (motivos.length === 0 && !dadaDeBajaPorNombre) return null;
  return (
    <Alert variant="error" icon={<IconBan size={18} />} title="Baja por Mesa de Control">
      <Text size="sm" className="mt-1">
        {dadaDeBajaPorNombre ? (
          <>
            Dada de baja por <Text span fw={600}>{dadaDeBajaPorNombre}</Text> (Mesa de
            Control){dadaDeBajaAt ? ` el ${formatFecha(dadaDeBajaAt)}` : ""}.{" "}
          </>
        ) : null}
        Acción terminal · si necesitas continuar el pago, inicia una solicitud
        nueva desde cero.
      </Text>
      {motivos.length > 0 && (
        <Stack gap={4} className="mt-2">
          <Text size="xs" fw={600}>Motivos:</Text>
          {motivos.map((m, i) => (
            <Text key={i} size="xs">• {m}</Text>
          ))}
        </Stack>
      )}
    </Alert>
  );
}
